import React from "react";

// Standard reasons — kept consistent so the Insights breakdown charts stay clean & comparable.
export const LOSS_REASONS = [
  "Lost on price",
  "Lost on schedule",
  "Scope mismatch",
  "Relationship / incumbent",
  "Lost on terms",
  "No decision / project shelved",
  "Other",
];

export const WIN_REASONS = [
  "Best price",
  "Existing relationship",
  "Schedule / availability",
  "Technical approach",
  "Local presence",
  "Incumbent / repeat client",
  "Other",
];

const slug = (r) => r.replace(/[^a-z0-9]+/gi, "-").toLowerCase();

// Tidy preset chips that fill a reason note. Reusable across every close-a-pursuit flow.
export function ReasonChips({ reasons, value, onPick, testidPrefix = "reason", tone = "rose" }) {
  const sel = tone === "emerald"
    ? "bg-emerald-600 text-white border-emerald-600"
    : "bg-rose-600 text-white border-rose-600";
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${testidPrefix}-presets`}>
      {reasons.map((r) => (
        <button
          key={r}
          type="button"
          onClick={() => onPick(r)}
          data-testid={`${testidPrefix}-${slug(r)}`}
          className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${value === r ? sel : "text-slate-600 border-slate-200 hover:bg-slate-50"}`}
        >
          {r}
        </button>
      ))}
    </div>
  );
}

export function LossReasonChips({ value, onPick, testidPrefix = "loss-reason" }) {
  return <ReasonChips reasons={LOSS_REASONS} value={value} onPick={onPick} testidPrefix={testidPrefix} tone="rose" />;
}
